/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailersListNewTrailer: "trailers-list-new-trailer",
} as const;
